<template>
  <div class="c-subCategoryList">
    <div class="c-subCategoryList_inner">
      <div class="c-subCategoryList_main">
        <h3 class="c-subCategoryList_headline">
          <nuxt-link
            class="c-subCategoryList_headlineLink"
            :to="parentCategoryRoute()"
          >
            <img
              v-if="isProCert"
              class="c-subCategoryList_headlineIcon"
              src="~/assets/images/common/pro-icon-outline.svg"
              alt=""
              aria-hidden="true"
              loading="lazy"
            >
            <coconala-icon
              v-else
              :name="`category-${category.romaji}`"
              size="26px"
              aria-hidden="true"
            />
            <span class="c-subCategoryList_headlineText">{{ category.name }}</span>
          </nuxt-link>
        </h3>
        <ul class="c-subCategoryList_list">
          <li
            class="c-subCategoryList_listItem"
            v-if="isFortuneCategory"
          >
            <nuxt-link
              class="c-subCategoryList_listItemLink"
              :to="phoneConsultationServiceListRoute()"
            >
              <span>電話占い</span>
            </nuxt-link>
          </li>
          <li
            class="c-subCategoryList_listItem"
            v-for="subCategory in category.subCategories"
            :key="`subCategory${subCategory.id}`"
          >
            <nuxt-link
              class="c-subCategoryList_listItemLink"
              :to="categoryRoute(subCategory)"
            >
              <span>{{ subCategory.name }}</span>
              <DNewLabel
                v-if="subCategory.isNewLabel"
                class="c-subCategoryList_newLabel"
              />
            </nuxt-link>
          </li>
          <!-- 関連カテゴリのリンクを表示 -->
          <li
            class="c-subCategoryList_listItem"
            v-for="relatedCategory in relatedCategories"
            :key="`relatedCategory${relatedCategory.id}`"
          >
            <nuxt-link
              class="c-subCategoryList_listItemLink"
              :to="categoryRoute(relatedCategory)"
            >
              {{ relatedCategory.name }}
            </nuxt-link>
          </li>
          <!-- 士業は法律相談へのリンクを表示 -->
          <li
            v-if="category.id === 13"
            class="c-subCategoryList_listItem"
          >
            <a
              class="c-subCategoryList_listItemLink"
              :href="legalUrl"
              target="_blank"
              rel="noopener"
            >
              法律相談・弁護士検索
              <coconala-icon
                class="c-subCategoryList_listItemIcon"
                name="external-link"
                size="10px"
                color="gray700"
              />
            </a>
          </li>
        </ul>
      </div>
      <div class="c-subCategoryList_search">
        <div class="c-subCategoryList_searchInner">
          <search-input
            initialPlaceholder="このカテゴリからサービスを探す"
            :dropdown="false"
            expanded
            @change="doSearch"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchInput from '~/components/molecules/SearchInput'
import SubCategoriesMixin from '@/mixins/category/sub-categories-mixin'

// vuex
import { mapGetters } from 'vuex'

/** @type {import('vue').ComponentOptions} */
const subCategoryList = {
  name: 'SubCategoryList',
  components: {
    SearchInput,
    DNewLabel: () => import('~/components/atoms/DS2/DNewLabel')
  },
  props: {
    category: {
      type: Object,
      required: true
    },
    parentCategoryId: {
      type: Number,
      default: 0
    },
    isProCert: {
      type: Boolean,
      default: false
    },
    legalUrl: {
      type: String,
      required: true
    }
  },
  mixins: [SubCategoriesMixin],
  computed: {
    ...mapGetters('constants', ['getRelatedCategories']),
    showPhoneServicesLink() {
      return !this.isProCert && !this.isOtherCategory
    },
    relatedCategories() {
      return this.getRelatedCategories(this.parentCategoryId)
    }
  },
  methods: {
    doSearch({ searchText }) {
      const baseQuery = {
        keyword: searchText,
        ref: 'top_categories',
        search_form: 'sidebar_category_pc'
      }
      const query = Object.assign(
        baseQuery,
        this.isProCert
          ? {
              provider_statuses: ['pro_service'],
              pro_priority_display: 1
            }
          : { category_id: this.category.id }
      )
      this.$router.push({
        name: 'search',
        query
      })
    }
  }
}
export default subCategoryList
</script>

<style lang="scss" scoped>
.c-subCategoryList {
  padding-left: 15px;
  &_inner {
    position: relative;
    z-index: z(dropdown-upper, content);
    padding: 16px 24px;
    min-width: 536px;
    width: 100%;
    border: 1px solid $color-gray-300;
    border-radius: 6px;
    background-color: $color-white;
    &::after {
      position: absolute;
      top: 64px;
      left: -14px;
      z-index: z(dropdown-upper, arrow);
      width: 14px;
      height: 15px;
      content: url('~assets/images/components/HomeMainContent/CategoryList/subcategory-box-tri.png');
      transform: scaleX(-1);
    }
  }
  &_main {
    padding-bottom: 12px;
  }
  &_search {
    padding-top: 12px;
    border-top: 1px solid $color-gray-300;
  }
  &_searchInner {
    width: 310px;
  }
  &_headlineLink {
    @include link-effect;

    position: relative;
    display: flex;
    color: $color-gray-900;
    font-weight: bold;
    font-size: 16px;
  }
  &_headlineIcon {
    width: 26px;
    height: 26px;
  }
  &_headlineText {
    margin-left: 6px;

    align-self: center;
  }
  &_list {
    display: grid;
    margin-top: 16px;

    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
  }
  &_listItem {
    width: 100%;
    white-space: nowrap;
    &:nth-child(odd) {
      padding-right: 32px;
    }
    &-first {
      order: -1;
    }
  }
  &_listItemIcon {
    margin-left: 4px;
  }
  &_listItemLink {
    @include link-effect;

    display: flex;
    color: $color-gray-900;
    font-size: 13px;
    line-height: 28px;

    align-items: center;
  }
  &_newLabel {
    margin-bottom: 2px;
    margin-left: 3px;
  }
}
.c-videoCameraIcon {
  color: $color-deep-blue-600;
}
</style>
